import Vue from "vue";
import Vuex from "vuex";
import { app } from "@/store/modules/app";
import Authentication from "@/store/modules/authentication/index.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    access_token: "",
    user_email: "",
    complete_registration: false,
    transactionDetails: {},
    data: {},
    userDetails: {},
    selctedPayMode: {},
    CreatedBeneDetails: null,
    showDialog: false,
    receipientListItems: [],
    selectedUserType: "",
    paymodeCountry: {
      paymode: "",
      country: "",
    },
    buscreatecountry: "",
    filterListofuser: null,
    selectedExportComp: "test",
    alert: { show: false, color: "info", message: "" },
    sessionOut: false,
  },
  getters: {
    getpreviouspageState: (state) => state.filterListofuser,
    getpaymodeCountry: (state) => state.paymodeCountry,
  },
  mutations: {
    setTransactionDetails(state, payload) {
      state.transactionDetails = { ...payload };
    },
    setPreviousPageState(state, payload) {
      console.log("state", payload);
      state.filterListofuser = payload;
    },
    setcomponentName(state, payload) {
      console.log("state", payload);
      alert(payload);
      state.selectedExportComp = payload;
    },

    setAlert(state, data) {
      Object.assign(state.alert, { color: "info", show: true }, data);
      state.alert = data;
    },
    setSessionOut(state, data) {
      state.sessionOut = data;
      console.log(" state.sessionOut", state.sessionOut);
    },
  }, // plugins: [createPersistedState()],
  actions: {
    setTransactionDetails({ commit }, transactionDetails) {
      commit("setTransactionDetails", transactionDetails);
    },
    savePreviousPageState({ commit }, payload) {
      commit("setPreviousPageState", payload);
    },
    savecomponentName({ commit }, payload) {
      alert(payload);
      commit("setcomponentName", payload);
    },
  },
  modules: {
    app,
    AuthenticationService: Authentication,
  },
});
